import {NgModule}                           from '@angular/core';
import {GridModule}                         from '@progress/kendo-angular-grid';
import {CommonModule}                       from '@angular/common';
import {ApTranslationModule}                from '../translation/ap-translation.module';
import {ApNewsOverviewComponent}            from './components/ap-news.component';
import {ApDashboardOverviewComponent}       from './components/ap-dashboard.component';
import {ButtonModule, DropDownButtonModule} from '@progress/kendo-angular-buttons';
import {DropDownsModule}                    from '@progress/kendo-angular-dropdowns';
import {FormsModule, ReactiveFormsModule}   from '@angular/forms';
import {ApCoreModule}                       from '../ap-core/ap-core.module';
import {ChartsModule}                       from '@progress/kendo-angular-charts';
import {SortableModule}                     from '@progress/kendo-angular-sortable';
import 'hammerjs';
import {ApMapModule}                        from '../map/ap-map.module';
import {ApDashboardRoutes}                  from './ap-dashboard.routes';
import {DatePickerModule}                   from '@progress/kendo-angular-dateinputs';
import {LayoutModule, PanelBarModule}       from '@progress/kendo-angular-layout';
import {GaugesModule}                       from '@progress/kendo-angular-gauges';
import {ApSectionHeaderModule}              from '../ap-section-header/ap-section-header.module';
import {ScrollViewModule}                   from '@progress/kendo-angular-scrollview';
import {ApIconModule}                       from '../icons/ap-icon.module';
import {ApWeatherComponent}                 from './components/ap-weather.component';
import {ApUtilsModule}                      from '../ap-utils';
import {ApClockComponent}                   from './components/ap-clock.component';
import {ApParameterEntryComponentsModule}   from '../entry-components/ap-parameter-entry-components/ap-parameter-entry-components.module';


@NgModule({
  declarations: [
    ApNewsOverviewComponent,
    ApDashboardOverviewComponent,
    ApWeatherComponent,
    ApClockComponent,
  ],
  exports: [
    ApNewsOverviewComponent,
    ApDashboardOverviewComponent,
    ApWeatherComponent,
    ApClockComponent,
  ],
  imports: [
    GaugesModule,
    ScrollViewModule,
    ApCoreModule,
    GridModule,
    ChartsModule,
    ApTranslationModule,
    CommonModule,
    ApTranslationModule,
    ReactiveFormsModule,
    ButtonModule,
    FormsModule,
    DropDownsModule,
    DropDownButtonModule,
    ApMapModule,
    SortableModule,
    ApDashboardRoutes,
    DatePickerModule,
    LayoutModule,
    PanelBarModule,
    ApSectionHeaderModule,
    ApIconModule,
    ApUtilsModule,
    ApParameterEntryComponentsModule,
  ]
})
export class ApDashboardModule {
}
